export const AFFILIATE_SIGNUP_INTENT_COOKIE = "affiliate_signup_intent";
export const AFFILIATE_SIGNUP_GTM_COOKIE = "affiliate_signup_gtm";
